import {AnyEvent, JOB_SECTION_ITEM_REORDERED, JobSectionItemReorderedEvent} from '../type';

export default function jobSectionItemReordered(payload: JobSectionItemReorderedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_ITEM_REORDERED,
    payload,
  }
}